import {useMutation, useQuery, useQueryClient} from 'react-query';
import {createRoadmap, deleteRoadmap, fetchRoadmap, fetchRoadmaps, generateRoadmapPreview, updateRoadmap} from '../api/roadmapApi';

export function useRoadmaps(token) {
    return useQuery({queryKey: ['roadmaps'], queryFn: () => fetchRoadmaps(token), enabled: !!token});
}

export function useRoadmap(token, roadmapId) {
    return useQuery({queryKey: ['roadmap', roadmapId], queryFn: () => fetchRoadmap(token, roadmapId), enabled: !!token && !!roadmapId});
}

export function useCreateRoadmap(token) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (roadmap) => createRoadmap(token, roadmap),
        onSuccess: () => queryClient.invalidateQueries(['roadmaps']),
    });
}

export function useGenerateRoadmap(token) {
    return useMutation({
        mutationFn: (request) => generateRoadmapPreview(token, request),
    });
}

export function useUpdateRoadmap(token) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({roadmapId, roadmap}) => updateRoadmap(token, roadmapId, roadmap),
        onSuccess: (updated) => {
            queryClient.setQueryData(['roadmap', updated.id], updated);
            queryClient.invalidateQueries(['roadmaps']);
        },
    });
}

export function useDeleteRoadmap(token) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (roadmapId) => deleteRoadmap(token, roadmapId),
        onSuccess: (_, roadmapId) => {
            queryClient.invalidateQueries(['roadmaps']);
            queryClient.removeQueries(['roadmap', roadmapId]);
        },
    });
}
